export const externalLinks = {
  legalNotice: "https://www.permuteo.fr/mentions-legales/",
  termsOfService: "https://permuteo.fr/conditions-generales-dutilisation/",
  support: "https://www.permuteo.fr/contact/",
  faq: "https://www.permuteo.fr/faq/",
  privacyPolicy: "https://permuteo.fr/politique-confidentialite/",
  rh: "https://permuteo.fr/ressources/",
  appstore: "https://itunes.apple.com/gb/app/teamsquare-sant%C3%A9/id1380639450?mt=8&amp;ign-mpt=uo%3D2",
  googleplay: "https://play.google.com/store/apps/details?id=com.hospimedia.switchapp",
}



// WEBPACK FOOTER //
// ./src/settings/externalLinks.js